import { render, staticRenderFns } from "./OverviewNotifications.vue?vue&type=template&id=32e4aedc"
import script from "./OverviewNotifications.vue?vue&type=script&lang=js"
export * from "./OverviewNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports